// Configuration du module ImageModule
import type { ComponentMetadata } from '../../G&CSCM/Core/types';

export const ImageModuleConfig: ComponentMetadata = {
    name: 'ImageModule',
    displayName: 'Image Optimisée',
    description: 'Affiche une image avec chargement progressif et optimisation automatique',
    category: 'Media',
    defaultParams: {
        src: '/vite.svg',
        alt: 'Image exemple',
        loadOriginal: true
        // quality: vide par défaut pour auto-détection
    },
    paramDefinitions: {
        fileId: {
            type: 'string',
            label: 'ID Fichier API',
            description: 'ID du fichier dans l\'API (optionnel, laissez vide si src est utilisé)',
            file_types: 'File(image)',
            editable_by_dev: true,
            editable_by_user: true  // Les utilisateurs peuvent changer l'image
        },
        src: {
            type: 'string',
            label: 'Source locale',
            description: 'Chemin vers l\'image locale (optionnel, laissez vide si fileId est utilisé)',
            editable_by_dev: true,
            editable_by_user: false  // Les utilisateurs peuvent changer l'image locale
        },
        alt: {
            type: 'string',
            label: 'Texte alternatif',
            description: 'Description de l\'image pour l\'accessibilité',
            editable_by_dev: true,
            editable_by_user: true  // Les utilisateurs peuvent modifier le texte alternatif
        },
        quality: {
            type: 'number',
            label: 'Qualité (%)',
            description: 'Qualité JPEG 1-95%. Laisser VIDE pour auto-détection selon connexion (50%, 75%, ou 85%)',
            editable_by_dev: true,
            editable_by_user: false  // Les utilisateurs ne doivent pas modifier la qualité
        },
        width: {
            type: 'number',
            label: 'Largeur (px)',
            description: 'Largeur en pixels. Laisser vide pour auto-détection (400px, 800px, ou 1920px)',
            editable_by_dev: true,
            editable_by_user: false  // Les utilisateurs ne doivent pas modifier la largeur
        },
        height: {
            type: 'number',
            label: 'Hauteur (px)',
            description: 'Hauteur en pixels (optionnel)',
            editable_by_dev: true,
            editable_by_user: false  // Les utilisateurs ne doivent pas modifier la hauteur
        },
        loadOriginal: {
            type: 'boolean',
            label: 'Charger original',
            description: 'Charger l\'original (95% @ 1920px) en arrière-plan après la version optimisée',
            editable_by_dev: true,
            editable_by_user: false  // Les utilisateurs ne doivent pas contrôler le chargement original
        }
    },
    outsideGrid: false,
    defaultEnabled: true
};

export default ImageModuleConfig;
